define('prototypes/WebSocket',[],function(){

    var WebSocketConnection = function(){

        var wsUri,
            restartTimeout,
            restartTryoutMax, // tryout infinite by default
            restartTryoutCount = 0,
            websocket,
            connected;

        function setup(app){
            var wsEnabled = app.c('_WEBSOCKET_ENABLE_',false)==1;

            if(!wsEnabled) return;
            //
                wsUri = app.c('_WEBSOCKET_URI_','ws://127.0.0.1:5100'),
                restartTimeout = parseInt(app.c('_WEBSOCKET_RESTART_TIMEOUT_',10000)),
                restartTryoutMax = parseInt(app.c('_WEBSOCKET_RESTART_TRYOUT_',0)), // tryout infinite by default
                restartTryoutCount = 0,
                websocket,
                connected = false;

            init();
        }

        function init()
        {
            restartTryoutCount++;
            try {
                websocket = new WebSocket(wsUri,'public');
                websocket.onopen = function(evt) { onOpen(evt) };
                websocket.onclose = function(evt) { onClose(evt) };
                websocket.onmessage = function(evt) { onMessage(evt) };
                websocket.onerror = function(evt) { onError(evt) };
            }catch (error) {
            }
        }

        function onOpen(evt)
        {
            connected = true;
            restartTryoutCount = 0;
        }

        function onClose(evt)
        {
            connected = false;
            // auto-reconnect, with timeout and tryout
            if(restartTryoutMax<=0 || restartTryoutCount<restartTryoutMax){
                setTimeout(init, restartTimeout);
            }else{
            }
        }

        function onMessage(evt)
        {
            try{
                var messageJSON = JSON.parse(event.data);
                if(messageJSON.type){
                    app.trigger('ws__'+messageJSON.type,messageJSON);
                }
            }catch(err){
            }
        }

        function onError(evt)
        {
        }

        // function doSend(message)
        // {
        //     websocket.send(message);
        // }

        // public methods
        return {
            setup:setup
        }
    };
    return WebSocketConnection();
});
